import { useEffect, useState } from 'react';
import axios from 'axios';
import AdminLayout from '@/components/admin/AdminLayout';
import { Trash2, Star, User } from 'lucide-react';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminReviews = () => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchReviews();
  }, []);

  const fetchReviews = async () => {
    try {
      const response = await axios.get(`${API}/admin/reviews`);
      setReviews(response.data);
    } catch (error) {
      toast.error('Erro ao carregar avaliações');
    } finally {
      setLoading(false);
    }
  };

  const deleteReview = async (reviewId) => {
    if (!window.confirm('Tem certeza que deseja deletar esta avaliação?')) return;
    
    try {
      await axios.delete(`${API}/admin/reviews/${reviewId}`);
      toast.success('Avaliação deletada!');
      fetchReviews();
    } catch (error) {
      toast.error('Erro ao deletar avaliação');
    }
  };

  const renderStars = (rating) => {
    return (
      <div className="flex gap-1">
        {[1, 2, 3, 4, 5].map((star) => (
          <Star
            key={star}
            className={`h-4 w-4 ${star <= rating ? 'fill-primary text-primary' : 'text-zinc-600'}`}
          />
        ))}
      </div>
    );
  };

  return (
    <AdminLayout>
      <div data-testid="admin-reviews-page">
        <h1 className="font-heading text-4xl font-bold text-white mb-8">Avaliações</h1>

        {loading ? (
          <div className="flex items-center justify-center py-20">
            <div className="h-16 w-16 border-4 border-primary border-t-transparent rounded-full animate-spin" />
          </div>
        ) : (
          <div className="space-y-4">
            {reviews.map((review) => (
              <div key={review.id} className="bg-zinc-900/50 border border-white/10 p-6">
                <div className="flex gap-4">
                  {/* Product Image */}
                  {review.product_info && (
                    <img
                      src={review.product_info.image}
                      alt={review.product_info.name}
                      className="w-24 h-24 object-cover border border-white/10"
                    />
                  )}

                  {/* Review Content */}
                  <div className="flex-1">
                    <div className="flex items-start justify-between mb-3">
                      <div>
                        {review.product_info && (
                          <h3 className="font-heading text-lg font-bold text-white mb-1">
                            {review.product_info.name}
                          </h3>
                        )}
                        <div className="flex items-center gap-3">
                          <div className="flex items-center gap-2 text-zinc-400">
                            <User className="h-4 w-4" />
                            <span className="text-sm font-bold">{review.customer_name}</span>
                          </div>
                          <span className="text-xs text-zinc-500">
                            {new Date(review.created_at).toLocaleDateString('pt-BR')}
                          </span>
                        </div>
                      </div>
                      <button
                        onClick={() => deleteReview(review.id)}
                        className="p-2 text-red-500 hover:bg-red-500/10 rounded transition-colors"
                      >
                        <Trash2 className="h-5 w-5" />
                      </button>
                    </div>

                    <div className="mb-3">
                      {renderStars(review.rating)}
                    </div>

                    <p className="text-zinc-300 leading-relaxed">{review.comment}</p>
                  </div>
                </div>
              </div>
            ))}

            {reviews.length === 0 && (
              <div className="text-center py-20 text-zinc-400">
                Nenhuma avaliação ainda
              </div>
            )}
          </div>
        )}
      </div>
    </AdminLayout>
  );
};

export default AdminReviews;